import { queryClient, useMutation } from '../../../ReactQuery';
import { remove } from '../../../redux/api';
import type { GetBannersResponse } from '../../../../shared/types/routes/banners';

import { bannersQueryKey } from './useBanners';

const deleteBanner = (id: number) =>
  remove(`/api/banners/${id}`);

/**
 * Hook for deleting a banner.
 */
export default function useDeleteBanner() {
  return useMutation<number, Response>({
    mutationFn: deleteBanner,
    onSuccess: (_response, id: number) => {
      //  Update the banners query cache
      queryClient.setQueryData<GetBannersResponse>(bannersQueryKey, (banners?: GetBannersResponse) => {
        return (banners ? banners.filter((banner) => banner.id !== id) : []) as GetBannersResponse;
      });
    },
  });
}
